import { render, staticRenderFns } from "./TipsDialog.vue?vue&type=template&id=3aa33a95&scoped=true"
import script from "./TipsDialog.vue?vue&type=script&lang=js"
export * from "./TipsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa33a95",
  null
  
)

export default component.exports